import "../../../bryntum-lib/editors/importCsv/ImportBase.jsx";
import SwivuModal from "./SwivuModal.jsx";
import { WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";
import { useCallback } from "react";
import { useHistory } from "react-router-dom";

const ImportPopup = ({ isShow, context, record, onClose, editorInstance }) => {
  const history = useHistory();
  const onShowHandler = useCallback((editor, otherParams) => {
    editor.editRecord(record, context, { ...otherParams, history });
    editorInstance.editorRef = editor;
  }, [context, editorInstance, history, record]);
  return (
    <SwivuModal
      widgetType={WIDGET_KEYS.importEditorType}
      isShow={isShow}
      onHide={() => {
        editorInstance.editorRef.widgetMap.filePicker.clear();
        onClose();
      }}
      onShow={onShowHandler}
    />
  )
};

export default ImportPopup;
